<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Fleet Master</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Terms &amp; Policy
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  v-if="isAllowToCreate"
                  class="btn btn-primary pull-left"
                  @click="createItem()"
                >
                  <span>&#43;</span> Create New
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Terms <span><i class="ic-car"></i></span>
                  </h2>
                  <p>Manage all terms and policies for your suppliers and partners.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search Provider Name"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option v-for="item in table.pageSizes" :value="item" :key="item">
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-p15">
            <table class="table table-hover table-fix table-sticky">
              <thead>
                <tr>
                  <th>
                    Title
                    <span class="button-sort" @click="onClickSort('title')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span>
                  </th>
                  <th>
                    Provider
                    <span class="button-sort" @click="onClickSort('provider.name')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span>
                  </th>
                  <th class="text-center">Source</th>
                  <th class="text-center">Status</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{ item.title }}</td>
                  <td>{{ item.providerName }}</td>
                  <td class="text-center">{{ item.source }}</td>
                  <td class="text-center">
                    <label class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="item.isActive"
                        :disabled="!item.isOwnInventory || !isAllowToUpdate"
                        @change="changeStatus(item)"
                      />
                      <span class="pl-5 font-weight-normal v-align-middle">
                        {{ item.isActive ? "Active" : "Inactive" }}
                      </span>
                    </label>
                  </td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        v-if="item.isOwnInventory && isAllowToUpdate"
                        class="btn btn-default"
                        type="button"
                        @click.prevent="updateItem(item)"
                      >
                        <span>Edit</span>
                      </button>
                      <button
                        v-if="item.isOwnInventory && isAllowToDelete"
                        class="btn btn-default"
                        type="button"
                        @click.prevent="openDeleteModal('policy', item.id)"
                      >
                        <i class="ic-close"></i>
                      </button>
                      <button
                        v-if="!item.isOwnInventory"
                        class="btn btn-default"
                        type="button"
                        @click="viewItem(item)"
                      >
                        <span>View</span>
                      </button>
                      <button
                        v-if="isAllowToReadCoverageArea"
                        class="btn btn-default"
                        type="button"
                        @click.prevent="viewPolicyCoverageArea(item)"
                      >
                        <span>Area</span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="policymodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Policy</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="form-group">
                      <label class="required">Provider</label>
                      <v-select
                        class="v-search-select"
                        :class="{
                          'field-error': isSubmitted && $v.model.providerId.$error,
                        }"
                        placeholder=""
                        label="name"
                        v-model="model.providerId"
                        :options="providers"
                        :clearable="true"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.id"
                        :disabled="isViewOnly"
                        @input="onChangeProvider(model)"
                      >
                      </v-select>
                      <small
                        class="form-text sts-danger"
                        v-if="isSubmitted && !$v.model.providerId.required"
                        >Provider is required</small
                      >
                    </div>
                    <div class="form-group">
                      <label class="required">Policy Title</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{
                          'field-error': isSubmitted && $v.model.title.$error,
                        }"
                        v-model="model.title"
                        :disabled="isViewOnly"
                        placeholder="Rental Name Policy 1"
                        required
                      />
                      <div v-if="isSubmitted && $v.model.title.$error">
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.title.required"
                          >Title is required</small
                        >
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.title.maxLength"
                          >Title should be less than
                          {{ $v.model.title.$params.maxLength.max }} characters</small
                        >
                      </div>
                    </div>
                    <!-- <div class="form-group">
                      <div class="--blue25">
                        <strong>Select Available</strong>
                      </div>
                      <div class="btn-group-checkbox">
                        <div class="checkbox">
                          <label>
                            <input
                              type="checkbox"
                              name="isRefundable"
                              v-model="model.isRefundable"
                              :disabled="isViewOnly"
                            />
                            Refundable
                          </label>
                        </div>
                        <div class="checkbox">
                          <label>
                            <input
                              type="checkbox"
                              name="isRescheduleAvailable"
                              v-model="model.isRescheduleAvailable"
                              :disabled="isViewOnly"
                            />
                            Reschedule
                          </label>
                        </div>
                      </div>
                    </div> -->
                    <div class="form-group">
                      <label class="required">Term and Condition</label>
                      <textarea
                        class="form-control"
                        :class="{
                          'field-error': isSubmitted && $v.model.termAndCondition.$error,
                        }"
                        rows="3"
                        v-model="model.termAndCondition"
                        :disabled="isViewOnly"
                        required
                      ></textarea>
                      <small
                        class="form-text sts-danger"
                        v-if="isSubmitted && !$v.model.termAndCondition.required"
                        >Term and Condition is required</small
                      >
                    </div>
                    <div class="modal-footer" v-if="!isViewOnly">
                      <button type="submit" class="btn btn-primary">
                        {{ isUpdate ? "Save Changes" : "Save" }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="deleteItem" @cancel="cancelDelete" />
    <policyCoverageAreaComponent></policyCoverageAreaComponent>
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import policyService from "@/services/master/policy/policyService.js";
import providerService from "@/services/master/provider/providerService.js";
import policyCoverageAreaComponent from "@/components/master/policy/PolicyCoverageArea";
import maverickMap from "@/plugins/google/map.js";

export default {
  components: {
    deleteModal,
    policyCoverageAreaComponent,
  },
  computed: {
    isAllowToReadCoverageArea: function () {
      return (
        this.allServices !== null &&
        this.allServices["PolicyCoverageArea"] &&
        this.allServices["PolicyCoverageArea"].includes("Read")
      );
    },
    isAllowToRead: function () {
      return (
        this.allServices !== null &&
        this.allServices["Policy"] &&
        this.allServices["Policy"].includes("Read")
      );
    },
    isAllowToCreate: function () {
      return (
        this.allServices !== null &&
        this.allServices["Policy"] &&
        this.allServices["Policy"].includes("Create")
      );
    },
    isAllowToUpdate: function () {
      return (
        this.allServices !== null &&
        this.allServices["Policy"] &&
        this.allServices["Policy"].includes("Update")
      );
    },
    isAllowToDelete: function () {
      return (
        this.allServices !== null &&
        this.allServices["Policy"] &&
        this.allServices["Policy"].includes("Delete")
      );
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        sort: "",
        sortDir: "",
      },
      isSubmitted: false,
      allServices: null,
      isViewOnly: false,
      deleteId: null,
      deleteOption: null,
      map: null,
      providers: [],
      defaultProviderId: null,
      items: [],
      model: {},
      isLoading: false,
      isUpdate: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        providerId: { required },
        title: { required, maxLength: maxLength(100) },
        termAndCondition: { required },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(publicSettings, "PageSize", 25);

    const profile = await this.$store.dispatch("user/getProfile");
    this.allServices = profile.services;

    if (this.isAllowToRead) {
      await this.getAll();
      await this.getProviders();

      if (profile.selectors && profile.selectors["Providers"]) {
        this.defaultProviderId = profile.selectors["Providers"].defaultId;
      }
    }
  },
  updated() {
    // subscribe message
    this.$eventBus.$on("openPolicyDeleteModal", this.openDeleteModal);
    this.$helper.collapseMenu("fleet-master");
    this.$helper.setNavigationClass("policy-link");
  },
  beforeDestroy() {
    this.$eventBus.$off("openPolicyDeleteModal");
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    async onClickSort(column) {
      if (this.table.sort === column) {
        this.table.sortDir = this.table.sortDir === "asc" ? "desc" : "asc";
      } else {
        this.table.sortDir = "asc";
      }
      this.table.sort = column;
      await this.getAll();
    },
    onChangeProvider(model) {
      model.providerCurrency = this.providers.find(
        (x) => x.id == model.providerId
      ).regionFormat.currencyCode;
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    openDeleteModal(option, id) {
      this.deleteOption = option;
      this.deleteId = id;
      $("#deletemodal").modal();
    },
    openModal(object) {
      this.resetValidations();
      this.model = Object.assign({}, object);
      $(this.$refs.policymodal).modal({ backdrop: "static", keyboard: false });
    },
    closeModal() {
      this.resetValidations();
      this.model = {};
      $(this.$refs.policymodal).modal("hide");
    },
    async getAll() {
      if (!this.isAllowToRead) {
        return;
      }
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        if (this.table.sort && this.table.sort !== "") {
          filter += `&sort=${this.table.sort}&sortDir=${this.table.sortDir}`;
        }
        const response = await policyService.getAll(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getProviders() {
      this.providers = await providerService.getAllActive();
    },
    createItem() {
      this.isViewOnly = false;
      this.isUpdate = false;
      this.openModal({ providerId: this.defaultProviderId });
    },
    updateItem(item) {
      this.isViewOnly = false;
      this.isUpdate = true;
      this.openModal(item);
    },
    viewItem(item) {
      this.isViewOnly = true;
      this.isUpdate = false;
      this.openModal(item);
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        if (this.isUpdate) {
          await policyService.update(this.model);
          this.$notification.success("Successfully updated.", { title: "Success" });
        } else {
          await policyService.create(this.model);
          this.$notification.success("Successfully added.", { title: "Success" });
        }
        await this.getAll();
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        await policyService.update(item);
        this.$notification.success("Successfully updated.", { title: "Success" });
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    cancelDelete() {
      switch (this.deleteOption) {
        case "policyCoverageArea":
          // publish message
          this.$eventBus.$emit("deletePolicyCoverageArea", this.deleteId);
          break;
      }
      this.deleteId = null;
      this.deleteOption = null;
      $("#deletemodal").modal("hide");
    },
    async deleteItem() {
      try {
        this.isLoading = true;
        switch (this.deleteOption) {
          case "policy":
            try {
              await policyService.delete(this.deleteId);
              this.$notification.success("Successfully deleted.", { title: "Success" });
              await this.getAll();
            } catch (error) {
              if (error.errors) {
                for (let index = 0; index < error.errors.length; index++) {
                  this.$notification.error(error.errors[index], { title: "Error" });
                }
              }
            }
            break;
          case "policyCoverageArea":
            // publish message
            this.$eventBus.$emit("openModalPolicyCoverageArea", this.deleteId);
            break;
        }
        this.deleteId = null;
        this.deleteOption = null;
        $("#deletemodal").modal("hide");
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    viewPolicyCoverageArea(item) {
      // publish message
      this.$eventBus.$emit("initializePolicyCoverageArea", item);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/policy/Policy.vue